import { useEffect, useState } from "react";

export interface UseNetworkState {
  /**
   * Whether or not the user is connected to a network.
   */
  online: boolean | undefined;
  /**
   * Previous value of `online` property. Helps to identify
   * if browser just connected or lost connection.
   */
  previous: boolean | undefined;
}

/** Helper fn to get connection info */
function getConnectionState(previousState?: UseNetworkState): UseNetworkState {
  const online = navigator?.onLine;
  const previousOnline = previousState?.online;

  return {
    online,
    previous: previousOnline,
  };
}

/**
 * Used to track the state of the user's network connection.
 */
export function useNetworkState() {
  const [state, setState] = useState(getConnectionState);

  useEffect(() => {
    const handleStateChange = () => {
      setState(getConnectionState);
    };

    window.addEventListener("online", handleStateChange, {
      passive: true,
    });
    window.addEventListener("offline", handleStateChange, {
      passive: true,
    });

    return () => {
      window.removeEventListener("online", handleStateChange);
      window.removeEventListener("offline", handleStateChange);
    };
  }, []);

  return state;
}
